import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.page.html',
  styleUrls: ['./invite.page.scss'],
})
export class InvitePage implements OnInit {
  referralMsg: any = "";
  referralCode: any;
  constructor(
    private userService: UserService, 
    private router: Router, 
    private socialSharing: SocialSharing, 
    private authService: StoreService) { }
    
  ngOnInit() {
    let a = {
      uid: this.userService.uid
    }
    this.userService.getUserDetails(a).subscribe((res: any) => {
      console.log("getUserDetails ", res);
      this.referralCode = res.referralCode || 'dfgfdgdfg'
      // this.referralMsg = "Start Shopping using referral code " + this.referralCode + " & earn 1000 SPOT Coins immediately!"
      this.referralMsg = "Dear Friend, I have thought you may be benefitted from the revolutionary smart-promotion app https://spotyourdeal.com which is a fast-growing SaudaNo1 portal in India. Please download the app https://play.google.com/store/apps/details?id=com.spot.mckinsol for your Android and iOS phone and avail some compelling and appealing promotions. You can also refer your friends to increase your number of promotions. Your Referral Code is: " + this.referralCode
      console.log(this.referralMsg)
    })
  }

  shareByFacebook() {

    let options = {
      message: this.referralMsg,
      subject: 'Spot Your Deal',
    }
    this.socialSharing.shareWithOptions(options).then((result) => {
      console.log("Share completed? ", result.completed);
      console.log("Shared to app: ", result.app);
    }, (err) => {
      console.log("Sharing failed with message: ", err);
    });
  }

  goBack() {
    this.router.navigate(['spot-wallet'])
  }
  home(){
    this.router.navigate(['/home'])
  }

}
